function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
import chroma from "chroma-js";
import { createColorSwatch, finalizeColorSwatch } from "../colorSwatch/colorSwatch";
import luminanceScales from "../utils/luminanceScales";
export function createColorStack(seedColor, label) {
    var useExact = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false, overrideColors = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
    if (chroma.valid(seedColor)) {
        var seed = chroma(seedColor).css();
        var defaultSwatches = buildSwatchesWithExact(seed, 'default', useExact, overrideColors.default);
        var darkSwatches = buildSwatchesWithExact(seed, 'dark', useExact, overrideColors.dark);
        return {
            label: label,
            get seedColor () {
                return seed;
            },
            get default () {
                return defaultSwatches;
            },
            get dark () {
                return darkSwatches;
            }
        };
    }
}
export default createColorStack;
export function finalizeColorStack(_param) {
    var defaultSwatches = _param.default, darkSwatches = _param.dark, restStack = _objectWithoutProperties(_param, [
        "default",
        "dark"
    ]);
    return _objectSpread({
        default: simplifySwatches(defaultSwatches),
        dark: simplifySwatches(darkSwatches)
    }, restStack);
}
function buildSwatchesWithExact(seed, themeName, useExact, overrideColors) {
    var swatchArray = buildSwatchArray(seed, themeName, overrideColors).filter(function(swatch) {
        return typeof swatch !== 'undefined';
    });
    var exactIndex = findIndexOfClosestContrast(swatchArray, seed);
    swatchArray[exactIndex].useExact = useExact;
    swatchArray[exactIndex].exactColor = seed;
    return swatchArray;
}
function findIndexOfClosestContrast(swatches, seed) {
    var _Math;
    var contrastToSeed = swatches.reduce(function(accumulator, swatch) {
        if (typeof swatch === 'undefined') {
            return accumulator;
        }
        var generatedColor = swatch.generatedColor;
        return _toConsumableArray(accumulator).concat([
            chroma.contrast(seed, generatedColor)
        ]);
    }, []);
    return contrastToSeed.indexOf((_Math = Math).min.apply(_Math, _toConsumableArray(contrastToSeed)));
}
function buildSwatchArray(seedColor) {
    var themeName = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 'default', overrideColors = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    return Object.keys(luminanceScales[themeName]).sort(sortScaleKeys).map(function(nominalContrast) {
        return createColorSwatch(seedColor, themeName, nominalContrast, overrideColors[nominalContrast]);
    });
}
function sortScaleKeys(_a, _b) {
    var a = sortValueReplacement(_a);
    var b = sortValueReplacement(_b);
    if (a < b) {
        return -1;
    }
    if (a > b) {
        return 1;
    }
    return 0;
}
function sortValueReplacement(value) {
    switch(value){
        case 'zero':
            return 0;
        case 'max':
            return Number.MAX_SAFE_INTEGER;
        default:
            if (typeof value === 'number') {
                return value;
            }
            return parseInt(value, 10);
    }
}
function simplifySwatches(themedSwatches) {
    return themedSwatches.reduce(function(accumulator, swatch) {
        return _objectSpread({}, accumulator, finalizeColorSwatch(swatch));
    }, {});
}
